export enum LoginFlow {
    NO_FLOW = -1,
    USER_PROFILE_LOGIN_FLOW = 0,
    FHLBANK_USER_LOGIN_FLOW = 1
}